import { useEffect } from "react";
import ComIQSurveyLanding from "./ComIQSurveyLanding";
import "./ComIQSurveyLanding.css";

export default function Landing() {
  useEffect(() => {
    // Fill a wide frame (crop top/bottom) so the artwork reads ~30% shorter and stays horizontal.
    const svg = document.querySelector(".comiq-landing .hero-art svg");
    if (svg) svg.setAttribute("preserveAspectRatio", "xMidYMid slice");
  }, []);
  return <ComIQSurveyLanding />;
}
